const backgroundColor = ({
  theme,
  error,
  help
}) => {
  if (error) return theme.orbit.paletteRedNormal;
  if (help) return theme.orbit.paletteBlueNormal;
  return theme.orbit.paletteInkDark;
};
export default backgroundColor;